const warehousingChart = {
  series: [
    {
      data: [],
    },
  ],
  chartOptions: {
    chart: {
      id: "mychart",
      height: 350,
      width: "100%",
      background: "#fff",
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    colors: ["#E33065", "#57697B"],
    plotOptions: {
      bar: {
        columnWidth: "40%",
        borderRadius: 2,
        distributed: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    xaxis: {
      categories: [
        {
          data: [],
        },
      ],
      labels: {
        style: {
          fontSize: "13px",
        },
        hideOverlappingLabels: true,
      },
      // title: {
      //   text: "Sku Code",
      //   // rotate: 360,
      //   offsetY: -10,
      //   offsetX: 460,
      // },
      axisBorder: {
        show: true,
        color: "#E33065",
      },
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return val.toFixed(0);
        },
        style: {
          fontSize: "13px",
          fontFamily: "Lato",
          fontWeight: 400,
          color: "#57697B",
        },
        hideOverlappingLabels: true,
      },
      decimalsInFloat: 0,
      axisBorder: {
        show: true,
        color: "#E33065",
      },
      title: {
        text: "Sold Quantities",
        rotate: 360,
        offsetY: -161,
        offsetX: 45,
      },
    },
  },
};
export { warehousingChart };
